<template>
    <div>
        <div>
            <div class="flex flex-row text-teal hover:text-teal-dark font-base text-sm mb-4">
                 <div @click="goBack" class="flex flex-row cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
            </div>
        </div>
        <div class="flex flex-row justify-around">
            <form @submit.prevent="saved" @keydown="form.errors.clear($event.target.name)"
                  class="flex flex-row justify-center w-full">
                <div class="rounded shadow-md w-full bg-white">
                    <div class="py-2 text-base text-grey-darkest pl-4 mb-8 border-b-2 border-followup-nav">
                        New Note
                    </div>

                    <div class="flex flex-row justify-content-between pl-8">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="note" :class="{'text-red': form.errors.has('note')}">Note</label>
                            <textarea rows="5" v-model="form.note" id="note" name="note"
                                   class="bg-white leading-loose tracking-wide shadow-sm appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                      :class="{'border-red': form.errors.has('note')}"></textarea>
                            <div class="text-red text-sm" v-if="form.errors.has('note')">{{ form.errors.get('note') }}</div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-end mt-4 pr-4 pb-4">
                        <a :href="`/company/${company.id}`" class="flex items-center mr-4 text-teal hover:text-teal-dark">
                            Cancel
                        </a>
                        <button class="py-2 px-4 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark"
                                :class="{'bg-teal-lighter cursor-not-allowed' : form.errors.any(), 'bg-teal' : !form.errors.any()}"
                                :disabled="form.errors.any()">
                            <span class="text-white font-bold">Create</span>
                        </button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>

<script>

    import Form from "../../utils/form";

    export default {
        name:'note-create',
        props: ['company'],

        data() {
            return {
                form: new Form({
                    note: '',
                }),
            }
        },

        methods: {
            saved() {
                let self = this;
                this.form.post(route('api.note.store', {company: this.company.id})).then(() => {
                    Swal.fire({
                        title: 'Created',
                        text: "Your note has been created.",
                        type: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: false,
                    }).then(() => {
                        window.location = "/company/" + self.company.id;
                    });
                });
            },

            goBack() {
                window.location = "/company/" + this.company.id;
            }
        }
    }
</script>
